import { Components, Theme } from '@mui/material'
import { palette } from '../palette'

export const MuiInputBase: Components<Omit<Theme, 'components'>>['MuiInputBase'] = {
  styleOverrides: {
    root: {
      borderRadius: 1,
      position: 'relative',
      fontSize: '14px',
      '&.Mui-disabled': {
        backgroundColor: palette.neutralLight[50],
        color: palette.neutralLight[900],
        '-webkit-text-fill-color': palette.neutralLight[900],
        'input, textarea': {
          '-webkit-text-fill-color': palette.neutralLight[900],
        },
        fieldset: {
          border: '1px solid rgba(0,0,0, 0.23)',
        },
      },
      '&.MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          border: `1px solid ${palette.purple[300]}`,
        },
      },
    },
  },
}
